var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRobot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.421 431.158H404.21V512H40.421zM206.395 274.766c-14.137 28.316-43.155 47.935-76.749 48.56l61.792 67.41h121.263l-106.306-115.97zM204.345 66.762l-74.698 81.49c33.595.624 62.614 20.243 76.749 48.56l59.846-65.288c-30.742-8.552-54.712-33.479-61.897-64.762zM128 188.632c-26.003 0-47.158 21.155-47.158 47.158s21.155 47.158 47.158 47.158 47.158-21.155 47.158-47.158-21.155-47.158-47.158-47.158zM289.684 0c-26.003 0-47.158 21.155-47.158 47.158s21.155 47.158 47.158 47.158 47.158-21.155 47.158-47.158S315.687 0 289.684 0zM413.106 182.5l-56.992-78.366c-8.829 10.279-19.983 18.503-32.656 23.821l46.188 63.51c-19.634 11.785-32.803 33.28-32.803 57.798v53.895h40.421v-53.895c0-14.859 12.089-26.947 26.947-26.947 14.859 0 26.947 12.089 26.947 26.947v53.895h40.421v-53.895c0-34.13-25.518-62.395-58.473-66.763z"
  })));
}

export default SvgRobot;